import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import './axios'
import utils from './utils/utils'
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'
import {zhTran} from './utils/zh'
Vue.prototype.zhTran = zhTran

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.mixin(utils);
Vue.prototype.moment = moment;
moment.locale("zh-cn");

//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let ref = '';
  //console.log("document.referrer.length",document.referrer.length)
  if (document.referrer.length > 0) {
    ref = document.referrer;
    console.log("ref",ref)
    getWhiteList().then(res=>{
      if(res.data.code == 200 && res.data.data!=null){
        let data = res.data.data;
        //判断来源地址是否为 白名单中的地址;
        let whiteItem = data.filter(i=>i.websiltUrl && ref.indexOf(i.websiltUrl)!=-1 && i.websiltUrl!='');
        let orderNoList = to.query.order
        // //console.log(whiteItem,to);
        // //console.log(to.query.order);
        // console.log("whiteItem",whiteItem)
        //console.log("orderNoList",orderNoList)
        if(true){
          if(to.name == 'index'){
            router.replace("/orderSubmit")
          }
          sessionStorage.setItem("websiteName",whiteItem[0].websiteName);
          next();
        }else if(orderNoList && orderNoList.length>0){
          next();
        }else{
          ElementUI.MessageBox.alert('您的网站未授权，无法链接！','提示')
        }
      }else{
        //console.log("未获取到网站白名单列表！")
        next();
      }
    }).catch(err=>{
      next();
    })
  }else{
    if(to.name == 'index'){
      router.replace("/orderSubmit")
    }
    next();
  }

})
/**
 * 获取网站白名单列表
 * @returns {Promise<*>}
 */
async function getWhiteList(){
  let response;
  await webAxios.get("/slave/system/websiteWhitelist/list").then(res => {
    response = res;
  }).catch(err => {
    //console.log("获取网站白名单列表失败",err)
  })
  return response
}
Vue.mixin({
  mounted() {
    zhTran()
  }
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

